import React from 'react';
import { Grid } from 'semantic-ui-react';

import { TitledCard } from './TitledCard';
import { isNullOrUndefined } from '../../../node_modules/util';

const FormattedData = ({ data, title }) => {
  if (!data) {
    return <TitledCard title={title}>No data found.</TitledCard>;
  }
  const entries = Object.entries(data);

  const isJsonOrObject = value => {
    try {
      if (typeof value === 'object') {
        return value;
      }
      var obj = JSON.parse(value);
      if (obj && typeof obj === 'object') {
        return obj;
      }
    } catch (e) {}
    return false;
  };

  return (
    <TitledCard title={title}>
      <Grid>
        {entries.length > 0 ? (
          entries.map(keyValuePair => {
            const key = keyValuePair[0];
            const value = keyValuePair[1];
            if (isNullOrUndefined(key)) {
              return null;
            }

            const obj = isJsonOrObject(value);

            return obj ? (
              <Grid.Row key={key} columns={1}>
                <Grid.Column>
                  <FormattedData title={key} data={obj} />
                </Grid.Column>
              </Grid.Row>
            ) : (
              <Grid.Row key={key} columns={2}>
                <Grid.Column>{key}</Grid.Column>
                <Grid.Column>
                  {isNullOrUndefined(value) || value === ''
                    ? 'Null'
                    : value.toString()}
                </Grid.Column>
              </Grid.Row>
            );
          })
        ) : (
          <Grid.Row>
            <Grid.Column>No data found.</Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </TitledCard>
  );
};

export { FormattedData };



// WEBPACK FOOTER //
// ./src/components/layout/FormattedData.js